export const privacyPolicyHTML = `<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN">
<html>
<head>
	<meta http-equiv="content-type" content="text/html; charset=utf-8"/>
	<title></title>
	<meta name="generator" content="LibreOffice 6.4.7.2 (Linux)"/>
	<meta name="created" content="2023-04-28T13:36:00"/>
	<meta name="changedby" content="Guilherme Hackerott"/>
	<meta name="changed" content="2023-05-02T14:27:00"/>
	<meta name="AppVersion" content="16.0000"/>
	<meta name="DocSecurity" content="0"/>
	<meta name="HyperlinksChanged" content="false"/>
	<meta name="LinksUpToDate" content="false"/>
	<meta name="ScaleCrop" content="false"/>
	<meta name="ShareDoc" content="false"/>
	<style type="text/css">
		@page { size: 21.59cm 27.94cm; margin-left: 2.54cm; margin-right: 2.54cm; margin-top: 0.64cm; margin-bottom: 0.64cm }
		p { margin-bottom: 0.25cm; direction: ltr; line-height: 115%; text-align: left; orphans: 2; widows: 2; background: transparent }
		a:link { color: #0000ff; text-decoration: underline }
	</style>
</head>
<body lang="pt-BR" link="#0000ff" vlink="#800000" dir="ltr">
<div title="header"><p align="center" style="margin-bottom: 0cm; line-height: 100%">
	    
	

	                                                    
	</p>
	<p align="center" style="margin-bottom: 3.27cm; line-height: 100%"> 
	                                                                    
	                                                                    
	   <font color="#666666"><font face="Arial, serif"><font size="1" style="font-size: 8pt">Última
	atualização: 15/06/2026</font></font></font></p>
</div><p align="center" style="margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<p align="center" style="margin-bottom: 0cm; line-height: 150%"><font color="#38761d"><font face="Arial, serif"><font size="4" style="font-size: 14pt"><i><b>POLÍTICA
DE PRIVACIDADE DA PLATAFORMA VERT</b></i></font></font></font></p>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I">
	<li><p style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>DO
	PROPÓSITO DA POLÍTICA DE PRIVACIDADE</b></font></font></font></p>
</ol>
<p style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Bem-vindo
à plataforma da </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.,</b></font></font></font></p>
<p align="center" style="margin-bottom: 0cm; border: none; padding: 0cm; line-height: 150%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Esta
Política de Privacidade serve para dar-lhe confiança sobre nossas
medidas de proteção de privacidade e para que você saiba que nós
levamos sua privacidadeoridade muito a sério. Ela contém diretrizes
e informações que explicam como coletamos, usamos, compartilhamos e
armazenamos as informações dos usuários da Plataforma da </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
(“Usuários”) e dos serviços nela contidos </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">(&quot;Serviços&quot;),
incluindo o aplicativo </font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Guardian</b></font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">
e os módulos web de monitoramento de áreas e alertas associados a
ele,</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
e</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
o modo como você pode interagir com isto.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Nossa
política se aplica a todos os visitantes, clientes e outras pessoas
que utilizem a nossa Plataforma e os Serviços neles encontrados.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Ao
acessar ou usar a plataforma ou os Serviços você declara que leu e
aceitou os termos e condições desta Política de Privacidade.</b></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Para
que possamos manter uma relação de confiança com nossos </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">U</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">suários,
buscamos zelar pela privacidade dos mesmosdeles, razão pela qual
protegemos, da melhor forma possível, suas informações e dados
pessoais de perdas, uso impróprio e acesso não autorizado.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">No
intuito de propiciar uma experiência de alta qualidade e um serviço
superior ao Usuário, coletamos uma série de informações e
estatísticas, tais como: as fornecidas pelo próprio Usuário
(incluindo seus dados sensíveis); as decorrentes do tráfego gerado
pela Plataforma ou Serviço em si; as advindas do hardware utilizado
no acesso a Plataforma ou Serviço; e as inerentes à conexão do
Usuário à internet.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Nossa
Política de Privacidade se aplica a todos os visitantes, clientes e
outras pessoas que utilizem a nossa Plataforma e os Serviços nela
encontrados.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>AO
ACESSAR OU USAR A PLATAFORMA OU OS SERVIÇOS VOCÊ DECLARA QUE LEU E
ACEITOU OS TERMOS E CONDIÇÕES DESTA POLÍTICA DE PRIVACIDADE.</b></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="2">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>OS
	DADOS AS INFORMAÇÕES QUE COLETAMOS</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">No
intuito de propiciar uma experiência de alta qualidade e um serviço
superior aos Usuários, tratamos uma série de dados e estatísticas,
tais como: os fornecidos pelos próprios Usuários (incluindo seus
dados pessoais); os decorrentes do tráfego gerado pela Plataforma ou
Serviços em si; os advindos do hardware utilizado no acesso a
Plataforma ou Serviços; e os inerentes à conexão dos Usuários à
internet.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Para
que possamos ver como você usa a Plataforma ou os Serviços, nos
comunicar com você e, acima de tudo, garantir a prestação de um
bom serviço, nós coletamos:</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">As
	informações (dados pessoais e dados pessoais sensíveis) que nos
	são fornecidas para a criação de uma conta na Plataforma (nome de
	usuário, senha, e-mail, nome, sobrenome, telefone, data de
	aniversário, etc.) durante a utilização dos Serviços;</font></font></font></p>
</ul>
<p align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">As
	informações inerentes ao conteúdo produzido pelos Usuários,
	durante a utilização dos Serviços;</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
	registros das comunicações que temos com você (e-mails,
	etce-mails etc.).</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">As
	informações de atividades advindas do seu navegador, incluindo o
	endereço IP.</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
	cookies e tecnologias similares. Um cookie é uma pequena cadeia de
	dados, que muitas vezes inclui um identificador único e anônimo,
	enviado para o seu navegador, e que fica armazenado no disco rígido
	de seu computador. Eles visam, entre outras coisas,
	permitir/facilitar o seu acesso a todos os recursos disponibilizados
	pela </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	e viabilizar a segmentação de comunicados, anúncios e ofertas de
	seu interesse em nossa Plataforma ou Serviços nele encontrados.</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">As
	informações referentes à medição do tráfego gerado pelo uso
	dos Serviços, obtidas através de ferramentas de terceiros; e</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
	identificadores de dispositivo (destinados a otimizar a utilização
	da Plataforma e Serviços) e metadados (como, por exemplo, os dados
	técnicos associados ao conteúdo gerado pelos Usuários, que
	possibilitam a geolocalização destedo mesmo  e a respectiva
	divulgação desta informação a terceiros e demais usuários dos
	Serviços).</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">No
	âmbito do aplicativo </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Guardian</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	e dos fluxos de monitoramento ambiental da </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">:
	dados de cadastro e solicitação de acesso; coordenadas e
	localização de áreas monitoradas; registros de alertas e
	solicitações de alerta; informações de detecção de focos de
	incêndio (incluindo integrações com fontes como FIRMS); fotos,
	documentos e demais anexos enviados em respostas de campo (por
	exemplo, arquivos KML/KMZ, PDF e compactados); histórico de ações,
	observações e comunicações relacionadas ao tratamento de alertas.</font></font></font></p>
</ul>
<p align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="3">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>COMO
	USAMOS OS DADOSAS INFORMAÇÕES QUE COLETAMOS</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Conforme
explicamos, Uusamos oas dados informações que coletamos,
basicamente, para fornecer um serviço seguro e de ótima qualidade. 
PortantoDentre outras coisas, então, podemos dizer que suas
informações são utilizadas para:</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Permitir
	que você acesse suas informações com facilidade, quando dentro da
	Plataforma ou durante a utilização dos Serviços;</font></font></font></p>
</ul>
<p align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Evitar
	que você não precise digitar novamente suas informações, sempre
	que visitar a plataforma ou utilizar qualquer Serviço;</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Fornecer
	soluções de t</font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">ecnologia</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	eficientes e confiáveis;</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Fornecer
	informações, anúncios e ofertas personalizadas para você e
	outras pessoas;</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Testar
	novos recursos e melhorar e monitorar a eficiência da Plataforma e
	dos Serviços nela contidos; e</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Monitorar
	indicadores, corrigir problemas de tecnologia e manter a sua
	segurança.</font></font></font></p>
</ul>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="4">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>COMO
	COMPARTILHAMOS AS INFORMAÇÕES</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Nós
não vendemos, trocamos ou alugamos as informações que coletamos;
as informações somente serão utilizadas para a realização de
atividades lícitas, preservação de direitos próprios ou de
terceiros ou para a estrita observância </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">ao
comando</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
legal ou judicial, conforme descrito nesta política, nos Termos de
Uso do Serviço e na Lei nº </font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>13.709/2019</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
rigor, o acesso às informações coletadas é limitado aos nossos
funcionários; todavia, podemos compartilhar as informações com:</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Organizações
	que nos ajudam a disponibilizar </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">a</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	Plataforma e os Serviços àa você (prestadores de serviço);</font></font></font></p>
</ul>
<p align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Parceiros
	comerciais, com quem a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
	ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
	mantém acordo de confidencialidade. Isto, eventualmente, pode
	permitir a criação de uma rede de anúncios direcionados àquilo
	que acreditamos ser de maior interesse para você;.</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Outros
	usuários da Plataforma ou dos Serviços, desde que a informação
	seja pública;</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Serviços
	de mídia social, a quem você nos autorizar; e</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Outras
	empresas que façam parte do grupo desenvolvedor da Plataforma e dos
	Serviços ou que venham fazer parte do mesmodele, em virtude de:
	aquisição, fusão, falência, dissolução, cisão, liquidação,
	etc.liquidação etc.</font></font></font></p>
</ul>
<p align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>V.	COMO
ARMAZENAMOS AS INFORMAÇÕES</b></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
não mede esforços para proteger suas informações, valendo-se dos
melhores meios tecnológicos da internet para garantir tanto a sua
segurança como a eficiência dos Serviços propriamente dito.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Mas
é importante destacar:</b></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">As
	informações que coletamos podem ser armazenadas e processadas no
	Brasil ou em qualquer outro país onde a </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
	ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 11pt">
	</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">(ou
	empresa do grupo) mantenha instalações.</font></font></font></p>
</ul>
<p align="justify" style="margin-left: 1.27cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Ao
	utilizar o aA Plataforma ou os Serviços você declara que entende e
	concorda com a possibilidade de transferência do armazenamento das
	informações para outro país, que pode ter leis de proteção de
	dados diferentes da do seu país de origem.</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ul>
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Nós
	utilizamos salvaguardas confiáveis para manter protegidas as
	informações coletadas; contudo, não temos como responder pelos
	eventuais danos decorrentes do acesso e/ou utilização por
	terceiros estranhos, seja culposa ou dolosamente. Do mesmo modo, a
	</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
	ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>
	S.A. </b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">isenta-se
	de responsabilidade em caso de falhas na disponibilidade,
	continuidade e utilidade  </font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">d</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">autilidade
	da Plataforma ou Serviços, que, por questões técnicas e
	operacionais, estejam fora do seu alcance, tais como “time out”,
	“arquivo não encontrado”, “página não aceita”, “falha
	de servidor” (incluindo eventual perda de informações em
	backup), etc.</font></font></font></p>
</ul>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<ol type="I" start="6">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>POR
	QUANTO TEMPO MANTEMOS ARMAZENADOS OS DADOS</b></font></font></font></p>
</ol>
<p align="justify" style="margin-left: 1.91cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
dados pessoais descritos nesta Política de Privacidade são
armazenados pelo tempo necessário ao atingimento de suas finalidades
acima descritas.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Dados
pessoais utilizados para a prestação dos serviços fornecidos pela</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>
</b></font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>
</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">são
armazenados pelo tempo necessário à realização dos serviços
contratados, atendendo ainda ao prazo de armazenamento determinado
pela legislação de regência, visando cumprimento de obrigações
legais e/ou legítimo interesse.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
dados fornecidos pelos Usuários assim poderão ser eliminados assim
que o Usuário o requisita ou quando estes não forem mais
necessários para o oferecimento dos serviços prestados pela </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font face="Arial, serif"><font size="3" style="font-size: 12pt">,</font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
ressalvadas razões legais para manutenção dos dados armazenados,
ainda que solicitada sua exclusão, ou para preservação e
resguardos dos direitos de titularidade da</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>
VERT ECOTECH S.A. </b></font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Além
disso, poderão ser armazenados dados pessoais destinados à
comprovação de seu consentimento para o tratamento de dados
pessoais do Usuário, seja ele cliente ou não.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="6">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>QUAIS
	OS DIREITOS DO TITULAR DOS DADOS</b></font></font></font></p>
</ol>
<p align="justify" style="margin-left: 0.64cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Com
base nos direitos previstos na Lei Geral de Proteção de Dados –
LGPD, lei federal nº 13.709/2018, os Usuários têm direito a:</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-left: 1.25cm; text-indent: -1.25cm; margin-bottom: 0cm; line-height: 150%">
<font color="#000000">• <font face="Arial, serif"><font size="3" style="font-size: 12pt">	Obter
a confirmação da realização do tratamento de dados pessoais a ele
relacionados;</font></font></font></p>
<p align="justify" style="margin-left: 1.25cm; text-indent: -1.25cm; margin-bottom: 0cm; line-height: 150%">
<font color="#000000">• <font face="Arial, serif"><font size="3" style="font-size: 12pt">	Acessar
os dados pessoais, solicitando que forneçamos as informações
relativas ao tratamento destes dados;</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000">•<font face="Arial, serif"><font size="3" style="font-size: 12pt">	Solicitar
a correção de dados pessoais eventualmente incompletos, inexatos ou</font></font></font></p>
<p align="justify" style="text-indent: 1.27cm; margin-bottom: 0cm; line-height: 150%">
<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">desatualizados;</font></font></font></p>
<p align="justify" style="margin-left: 1.27cm; text-indent: -1.27cm; margin-bottom: 0cm; line-height: 150%">
<font color="#000000">• <font face="Arial, serif"><font size="3" style="font-size: 12pt">	Solicitar
a eliminação de seus dados pessoais, solicitação que será
analisada podendo resultar na necessidade de manutenção de seu
armazenamento pela </font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
de acordo com as hipóteses previstas na LGPD, dentre eles o
cumprimento de obrigação legal, contratual ou exercício de
legítimo interesse;</font></font></font></p>
<p align="justify" style="margin-left: 1.27cm; text-indent: -1.27cm; margin-bottom: 0cm; line-height: 150%">
<font color="#000000">• <font face="Arial, serif"><font size="3" style="font-size: 12pt">	Portabilidade
dos dados pessoais a outros fornecedores de serviços e produtos,
ressalvadas as proteções legais à confidencialidade e propriedade
industrial da </font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">;</font></font></font></p>
<p align="justify" style="margin-left: 1.27cm; text-indent: -1.27cm; margin-bottom: 0cm; line-height: 150%">
<font color="#000000">• <font face="Arial, serif"><font size="3" style="font-size: 12pt">	Anonimização,
bloqueio e eliminação de dados pessoais cujo tratamento se mostre
desnecessário ou em desconformidade com a Lei Geral de Proteção de
Dados;</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000">•
<font face="Arial, serif"><font size="3" style="font-size: 12pt">	Ser
informado sobre os destinatários do compartilhamento dos dados
pessoais;</font></font></font></p>
<p align="justify" style="margin-left: 1.27cm; text-indent: -1.27cm; margin-bottom: 0cm; line-height: 150%">
<font color="#000000">• <font face="Arial, serif"><font size="3" style="font-size: 12pt">	Revogar
o consentimento para o tratamento dos dados pessoais, quando estes
forem tratados baseados no consentimento; e</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000">•
<font face="Arial, serif"><font size="3" style="font-size: 12pt">	Manifestar
oposição a tratamento que viole a LGPD.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Para
o exercício de qualquer dos seus direitos acima, bem como para o
direcionamento sobre dúvidas e questionamentos, você poderá
contactar a </font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
 através do endereço de e-mail </font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">contato@vertecotech.com.</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
</font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="6">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>COOKIES</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
website da</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>
VERT ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
 utiliza cookies quando os Usuários acessam nossa Plataforma ou
Serviços.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Cookies
consistem em mecanismos de coleta automática de dados relacionados à
navegação tais como endereço de IP, identificação das ações
realizadas na plataforma, comportamento dos Usuários, dentre outros.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
consentimento a esta Política implica na concordância quanto a
utilização dos cookies visando a melhoraria na experiência de
navegação na Plataforma ou Serviços.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Os
Usuários podem optar por recusar ou desabilitar os Cookies por meio
das configurações de seu navegador, estando ciente, todavia, que
algumas funcionalidades da Plataforma ou dos Serviços podem ter seu
funcionamento afetado.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="6">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>CONSENTIMENTO
	E DECLARAÇÕES DOS USUÁRIOS</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Ao
aceitar esta Política de Privacidade, o Usuário declara: (a) que a
</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
poderá efetuar o tratamento dos seus dados pessoais que forem
coletados em razão do uso da Plataforma ou dos Serviços; (b) ser
maior de 18 (dezoito) anos e que fez a leitura completa e atenta das
regras destes termos, estando plenamente ciente do seu teor e
conferindo sua manifestação livre, informada e inequívoca pela
qual concorda com o tratamento de seus dados pessoais para uma das
finalidades estabelecidas nesta Política de Privacidade. Caso não
esteja de acordo com o conteúdo desta Política de Privacidade, não
poderá acessar o website www.vertecotech.com; (c) se for
representante legal de uma empresa, possuir os poderes necessários e
específicos para aceitar os termos desta Política de Privacidade. </font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
Usuário é o único responsável pela exatidão e veracidade dos
dados que informar no ato de preenchimento do formulário de
cadastro. Caso identificada falsidade de informações cadastradas, a
</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
solicitará ao Usuário esclarecimentos, podendo, suspender ou
bloquear seu acesso se julgá-las inadequadas, se assim for
necessário.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Caso
a </font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
identifique o mau uso da sua Plataforma ou Serviços ou a violação
de direitos da propriedade intelectual de sua propriedade ou de
terceiros será solicitado ao Usuário esclarecimentos, podendo
bloquear ou encerrar seu acesso e tomar as medidas jurídicas e
administrativas cabíveis.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Na
hipótese de mudanças da finalidade para o tratamento de dados
pessoais não compatíveis com o consentimento original, a </font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
informará previamente o Usuário sobre as mudanças de finalidade
por meio do e-mail informado no momento do cadastramento. </font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Caso
o tratamento dos dados seja realizado com fundamento na base legal
“com consentimento”, o titular poderá revogá-lo caso discorde
das alterações. No mesmo ato, a </font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
informará as consequências caso o Titular não concorde com a nova
finalidade de tratamento de seus dados pessoais.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
Usuário se declara ciente de que os dados coletados e as atividades
registradas poderão ser compartilhados: (a) Com autoridades
judiciais, administrativas ou governamentais competentes, sempre que
houver determinação legal, requerimento, requisição ou ordem
judicial; (b) de forma automática em caso de operações societárias
como fusão, aquisição e incorporação; (c) para operadores que
efetuarão o tratamento de dados pessoais do Usuário e/ou (d)
empresas do grupo econômico do qual a </font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
é parte integrante e empresas parceiras para o fornecimento dos
Serviços.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
Usuário se declara ciente de que seu login e senha são de uso
pessoal e intransferível e que deverá mantê-los sob sigilo e em
ambiente seguro. O Usuário que utilizar login e senha de outra
pessoa ou cedê-la a outrem para que dela se utilize poderá incorrer
no crime tipificado no art. 308, do Código Penal.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="6">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>REVISÃO
	E ALTERAÇÃO DA POLÍTICA</b></font></font></font></p>
</ol>
<p align="justify" style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 150%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Visando
o constante aprimoramento da experiência do Usuário e dos serviços
prestados pela </font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">,
bem como, a busca pela constante melhoria rumo à conformidade às
leis e regramentos de proteção de dados, esta Política poderá
sofrer revisões e alterações de seus termos.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">É
recomendado aos nossos Usuários o acesso periódico em nosso website</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>
</b></font></font></font><a href="http://www.vertecotech.com/"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>http://www.vertecotech.com</b></font></font></a><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>.
</b></font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Faremos
esforços razoáveis para alertá-los dessas mudanças quando elas
ocorrerem.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="6">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>CANAIS
	DE COMUNICAÇÃO </b></font></font></font>
	</p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Caso
você tenha qualquer dúvida sobre os termos desta Política de
Privacidade, deseje fazer comentários ou sugestões, necessite de
quaisquer esclarecimentos, informações ou deseje fazer reclamações
ou denúncias sobre o que acredita tratar-se de tratamento de seus
dados pessoais em desconformidade à Lei Geral de Proteção de
Dados, solicitamos que entre em contato conosco nos seguintes
endereços, via correspondência física, mensagem via website ou
e-mail:<br/>
</font></font></font><br/>

</p>
<p align="justify" style="margin-left: 1.27cm; text-indent: -1.27cm; margin-bottom: 0cm; line-height: 150%">
<font color="#000000">• <font face="Arial, serif"><font size="3" style="font-size: 12pt">	</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Endereço</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">:
Avenida José Rocha Bomfim, nº 214, Bloco B, cj. 214, Loteamento
Center Santa Genebra, CEP 13080-650, ou por intermédio dos canais de
contato disponíveis em nosso website </font></font></font><a href="http://www.vertecotech.com/"><font face="Arial, serif"><font size="3" style="font-size: 12pt">http://www.vertecotech.com</font></font></a><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
 </font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000">•
<font face="Arial, serif"><font size="3" style="font-size: 12pt">	</font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>E-mail</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">:
</font></font></font><a href="mailto:contato@vertecotech.com"><font face="Arial, serif"><font size="3" style="font-size: 12pt">contato@vertecotech.com</font></font></a></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Solicitamos
que eventuais mensagens direcionadas via website ou e-mail contenham
como assunto “Dados pessoais” à frente de quaisquer outros
termos.</font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<ol type="I" start="6">
	<li><p align="justify" style="margin-bottom: 0cm; line-height: 150%">
	<font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>DA
	LEI APLICÁVEL E JURISDIÇÃO</b></font></font></font></p>
</ol>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
presente Política de Privacidade será regida e interpretada segundo
a legislação brasileira, sendo eleito o Foro da Comarca de
Campinas/SP para dirimir qualquer litígio ou controvérsia
envolvendo a presente, salvo ressalva específica de competência
pessoal, territorial ou funcional pela legislação aplicável.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>
</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">se
comunicará com os Usuários através de área específica dentro da
própria Plataforma, por e-mail ou, ainda, outras formas eletrônicas
de comunicação, para promover avisos relacionados ao A Plataforma e
aos Serviços, incluindo os de natureza legal, e, se autorizado,
noticiando alterações dos recursos do Da Plataforma e dos Serviços
e encaminhando ofertas especiais, incluindo anúncios publicitários
direcionados à gama de interesse do Usuário.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p style="margin-left: 1.25cm; margin-bottom: 0cm; line-height: 100%">
<br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>APLICATIVO
GUARDIAN E MONITORAMENTO DE ÁREAS</b></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Guardian</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
é o aplicativo e o conjunto de funcionalidades da </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>VERT
ECOTECH S.A.</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
destinados ao monitoramento de áreas ambientais, à gestão de
alertas e à comunicação com equipes de campo, proprietários e
responsáveis técnicos vinculados a projetos cadastrados na
Plataforma.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Ao
utilizar o Guardian — no aplicativo móvel ou nos módulos web
correspondentes — você poderá fornecer ou gerar, entre outros, os
seguintes dados: identificação e contato (nome, e-mail, telefone e
demais dados de cadastro); credenciais de acesso; coordenadas
geográficas e descrições de localização; solicitações e
registros de alertas; evidências fotográficas e documentais
enviadas em respostas de campo; e metadados técnicos associados a
esses arquivos e registros.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Esses
dados são tratados para: permitir o cadastro, a autenticação e a
gestão de permissões de acesso; viabilizar o monitoramento de áreas
e a detecção de riscos ambientais; registrar, acompanhar e
comunicar alertas e providências adotadas; armazenar evidências
necessárias à operação, à auditoria e ao cumprimento de
obrigações legais ou contratuais; e aprimorar a segurança,
confiabilidade e desempenho dos Serviços.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Quando
houver detecções automatizadas de focos de incêndio ou dados
provenientes de serviços de terceiros (como FIRMS/NASA), tais
informações poderão ser associadas a solicitações e alertas no
Guardian, sempre no limite do necessário para a finalidade de
monitoramento e comunicação com os Usuários autorizados.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">O
tratamento de dados no Guardian observa as mesmas bases legais,
medidas de segurança e direitos dos titulares previstos nesta
Política de Privacidade e na legislação aplicável, inclusive o
direito de solicitar informações, correção, exclusão ou
revogação de consentimento, quando cabível, por meio do contato
</font></font></font><a href="mailto:contato@vertecotech.com"><font face="Arial, serif"><font size="3" style="font-size: 12pt">contato@vertecotech.com</font></font></a><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">.
Usuários do aplicativo móvel também poderão solicitar a exclusão
de solicitações de acesso pendentes pelos canais disponibilizados
na própria Plataforma.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>EXCLUINDO
CONTA e esclarecendo dúvidas</b></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Se
você deixar de concordar com os termos e condições de nossa
Política de Privacidade, poderá excluir sua conta </font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ecotech</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">,
sem qualquer problema.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Do
mesmo modo, caso você tenha dúvidas ou reclamações sobre esta
Política de Privacidade, fique à vontade para entrar em contato
conosco. </font></font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Alterações
desta Política de Privacidade</b></font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">A
</font></font></font><font color="#38761d"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Vert
ecotech</b></font></font></font><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">
se reserva ao direito de, a qualquer momento, alterar esta Política
de Privacidade, atualizando seu conteúdo, conforme as necessidades
de aperfeiçoamento tecnológico do Da Plataforma ou dos Serviços.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Faremos
esforços razoáveis para alertá-los dessas mudanças quando elas
ocorrerem.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><font color="#000000"><font face="Arial, serif"><font size="3" style="font-size: 12pt">As
alterações entram em vigor imediatamente após a publicação das
mesmas na área pertinente do aplicativo.</font></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 150%"><br/>

</p>
<div title="footer"><p align="right" style="margin-top: 1.8cm; margin-bottom: 0cm; line-height: 100%">
	<span style="background: #c0c0c0"><sdfield type=PAGE subtype=RANDOM format=PAGE></sdfield></span></p>
</div>
</body>
</html>`;